import { FC, useMemo } from "react";
import { Box, Typography } from "@material-ui/core";
import { InfoBox } from "componentsNew/elements/InfoBox";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { getFilteredPayrollRows, getPayrollTotals } from "utils/payrollHelpers";
import { useStyles } from "./styles";

const formatHours = (value: number) =>
  value.toLocaleString(undefined, { maximumFractionDigits: 2 });

const formatPay = (value: number) =>
  `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const PayrollStats: FC = () => {
  const classes = useStyles();
  const { dataList, payrollFilters } = useTypeSelectors((state) => state.payrollTable);

  const totals = useMemo(() => {
    const rows = getFilteredPayrollRows(
      dataList,
      payrollFilters.ordering,
      payrollFilters.search,
      payrollFilters.station,
      payrollFilters.userRole,
      payrollFilters.userStatus,
      payrollFilters.user?.id,
    );
    return getPayrollTotals(rows);
  }, [
    dataList,
    payrollFilters.ordering,
    payrollFilters.search,
    payrollFilters.station,
    payrollFilters.userRole,
    payrollFilters.userStatus,
    payrollFilters.user?.id,
  ]);

  return (
    <Box className={classes.statsSection}>
      <Box className={classes.statsContainer}>
        <Typography className={classes.statsTitle}>Payroll Summary</Typography>
        <Box className={classes.statsBox}>
          <InfoBox label={formatHours(totals.hours)} value="Hours" bigLabel />
          <InfoBox label={formatPay(totals.daPay)} value="DA Pay" bigLabel />
          <InfoBox label={formatPay(totals.agencyPay)} value="Agency Pay" bigLabel />
        </Box>
      </Box>
    </Box>
  );
};

export default PayrollStats;
